var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 45,
    viewBox: "0 0 32 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7913 17.2094V5.76883C20.7913 4.03127 19.3818 2.6217 17.6442 2.6217C15.9066 2.6217 14.499 4.03127 14.499 5.76883V15.2063",
    stroke: "url(#paint0_linear_842_4808)",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.082 23.7831L29.3302 9.62494C29.4484 9.23233 29.4873 8.82014 29.4447 8.41236C29.4021 8.00457 29.2789 7.60932 29.0821 7.2496C28.8854 6.88989 28.6191 6.57289 28.2987 6.31705C27.9783 6.06121 27.6102 5.87164 27.2159 5.75936C26.8237 5.64761 26.4134 5.61445 26.0084 5.66181C25.6034 5.70916 25.2118 5.83609 24.856 6.03529C24.5002 6.2345 24.1873 6.50205 23.9353 6.82258C23.6833 7.1431 23.4971 7.51028 23.3874 7.903L20.7908 17.2038M8.04611 16.7724L10.1058 21.3427C10.4241 22.0993 10.4343 22.9503 10.1341 23.7143C9.83387 24.4782 9.24707 25.0947 8.49882 25.4321C7.75056 25.7696 6.90008 25.8013 6.12874 25.5206C5.3574 25.2399 4.72626 24.669 4.36991 23.9295L2.30631 19.3592C2.13646 18.9823 2.0425 18.5756 2.02981 18.1625C2.01711 17.7493 2.08592 17.3376 2.23231 16.951C2.52796 16.1702 3.12166 15.5389 3.88281 15.1959C4.64395 14.8528 5.51019 14.8262 6.29096 15.1219C7.07173 15.4175 7.70308 16.0112 8.04611 16.7724Z",
    stroke: "url(#paint1_linear_842_4808)",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0465 22.6545C16.4465 21.5461 16.3989 20.3255 15.9137 19.2516L13.8189 14.6051C13.6515 14.234 13.4124 13.8996 13.1154 13.621C12.8185 13.3425 12.4694 13.1253 12.0883 12.982C11.7072 12.8387 11.3015 12.7721 10.8946 12.786C10.4877 12.7998 10.0875 12.8939 9.71706 13.0628C9.34074 13.2345 9.00269 13.4799 8.72291 13.7846C8.44313 14.0893 8.22732 14.447 8.08824 14.8365C7.94917 15.2261 7.88965 15.6396 7.91323 16.0526C7.93681 16.4655 8.04299 16.8696 8.2255 17.2408L8.48906 17.7796",
    stroke: "url(#paint2_linear_842_4808)",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2219 33.2259L21.1824 31.3048C21.205 31.2598 21.2175 31.2103 21.2189 31.1599C21.2203 31.1096 21.2106 31.0595 21.1904 31.0133C21.1703 30.9671 21.1403 30.9259 21.1025 30.8926C21.0646 30.8593 21.0199 30.8347 20.9716 30.8206L14.0409 28.7824C13.3681 28.5834 12.7861 28.1553 12.3956 27.5724C12.0052 26.9894 11.831 26.2883 11.9031 25.5904C11.9855 24.8053 12.3739 24.0844 12.9842 23.5837C13.5945 23.0831 14.3774 22.8431 15.1634 22.9157L24.5111 23.7864C24.5111 23.7864 31.9494 24.9305 29.3724 32.3669C26.7992 39.8052 25.9422 42.3783 20.2219 42.3783H10.4974C8.2975 42.3778 6.18783 41.5037 4.63226 39.9481C3.07669 38.3925 2.20255 36.2829 2.20203 34.0829L1.91504 18.0662",
    stroke: "url(#paint3_linear_842_4808)",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_842_4808",
    x1: 14.3849,
    y1: 10.2216,
    x2: 20.8939,
    y2: 10.2216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6430E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895EF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_842_4808",
    x1: 1.53059,
    y1: 16.0966,
    x2: 29.9086,
    y2: 16.0966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6430E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895EF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_842_4808",
    x1: 7.75567,
    y1: 17.9264,
    x2: 16.4526,
    y2: 17.9264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6430E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895EF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_842_4808",
    x1: 1.40702,
    y1: 30.7323,
    x2: 30.3714,
    y2: 30.7323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6430E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895EF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeace);
export default __webpack_public_path__ + "static/media/peace.8b449f3f05a4b0816871e7a9fae78b10.svg";
export { ForwardRef as ReactComponent };